import type { Tab } from "../types";

export const RECENT_CHAT_LIMIT = 5;

export function chatRowLabel(tab: Tab): string {
  const firstUser = tab.session.messages.find((m) => m.role === "user");
  if (firstUser?.content?.trim()) {
    return firstUser.content.trim().replace(/\s+/g, " ");
  }
  return tab.session.name;
}

export function chatScopeLabel(tab: Tab): string {
  if (Number.isFinite(tab.session.slideIndex) && tab.session.slideIndex >= 0) {
    return `Slide ${tab.session.slideNumber ?? tab.session.slideIndex + 1}`;
  }
  return "Overall";
}

export function chatsWithMessages(sortedTabs: readonly Tab[]): Tab[] {
  return sortedTabs.filter((tab) => tab.session.messages.length > 0);
}

export function recentChats(
  sortedTabs: readonly Tab[],
  limit: number = RECENT_CHAT_LIMIT
): Tab[] {
  return [...chatsWithMessages(sortedTabs)]
    .sort((a, b) => b.session.updatedAt - a.session.updatedAt)
    .slice(0, limit);
}
